import { render } from "./WidgetsContent.vue?vue&type=template&id=4d699b24"
import script from "./WidgetsContent.vue?vue&type=script&lang=js"
export * from "./WidgetsContent.vue?vue&type=script&lang=js"

import "./WidgetsContent.vue?vue&type=style&index=0&id=4d699b24&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__